import { combineReducers } from 'redux';
import carriers from './carriers';
import services from './services';
import ratecards from './ratecards';

export default combineReducers({
  entities: combineReducers({ carriers, services, ratecards }),
});
